import Layout from "@components/Layout"
import haptics from "@helpers/haptics"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

interface EmojiRatingPageProps {
  translationKey: string
  leftLabelKey: string
  rightLabelKey: string
}

const OPTIONS = [
  { emoji: "😔", rating: 1 },
  { emoji: "😐", rating: 2 },
  { emoji: "🙂", rating: 3 },
  { emoji: "😊", rating: 4 },
  { emoji: "🤩", rating: 5 },
]

export default function EmojiRatingPage({
  translationKey,
  leftLabelKey,
  rightLabelKey,
}: EmojiRatingPageProps) {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    haptics.trigger("selection")
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <h1 className="heading">
        {t(`pages.onboarding.${translationKey}.heading`)}
      </h1>

      <Form className="custom-form" method="post">
        <div className="flex grow flex-col items-center justify-center">
          <div className="w-full max-w-md">
            <div className="mb-4 flex w-full justify-between gap-1.5 sm:gap-2">
              {OPTIONS.map((item) => (
                <label
                  key={item.rating}
                  className="flex shrink-0 cursor-pointer flex-col items-center transition-transform hover:scale-105"
                >
                  <input
                    type="radio"
                    name={t(`pages.onboarding.${translationKey}.heading`, {
                      lng: "en",
                    })}
                    value={item.rating}
                    onChange={handleChange}
                    className="hidden"
                  />
                  <div className="bg-card hover:bg-card-hover flex h-14 w-14 flex-col items-center justify-center gap-1 rounded-xl border-2 border-gray-700/50 transition-all duration-200 hover:border-gray-600/50 sm:h-16 sm:w-16">
                    <span className="emoji text-2xl leading-none sm:text-3xl">
                      {item.emoji}
                    </span>
                    <span className="text-text-secondary text-xs">
                      {item.rating}
                    </span>
                  </div>
                </label>
              ))}
            </div>
            <div className="flex w-full justify-between">
              <span className="text-text-secondary text-xs font-semibold">
                {t(`pages.onboarding.${translationKey}.${leftLabelKey}`)}
              </span>
              <span className="text-text-secondary text-xs font-semibold">
                {t(`pages.onboarding.${translationKey}.${rightLabelKey}`)}
              </span>
            </div>
          </div>
        </div>
      </Form>
    </Layout>
  )
}
